<div class="component eventCard">


    <div class="pictureContainer">
        <!-- @if (event.pictures) { -->
        <div class="eventPicture" [ngStyle]="{'background-image': 'url('+ pictureLink +')'}"> </div>
        <!-- } -->

        <div class="eventDate">
            @if (event.date && (event.date.start || event.date.end)) {
            <span [ngStyle]="{'background-color': event.color}" [ngClass]="{'multiDays': event.date.end}">
                @if (event.date.start) { {{event.date.start | date : 'EE dd LLL yyyy':event.timezone?.name:'fr-FR'|
                titlecase}} }
                @if (event.date.end) { au {{event.date.end | date : 'EE dd LLL yyyy':event.timezone?.name:'fr-FR'|
                titlecase}} }
            </span>
            }
        </div>

        <div class="sticks-wrapper w-100">
            <div class="relavive-wrapper">
                @if (typeOfSportLabel) {<span class="stick typeOfSport">{{typeOfSportLabel}}</span>}
                @if (adminSide) {
                <div class="event-status-publication">
                    <span class="stick" [ngClass]="{'public': isEventVisible}">
                        @if (isEventVisible) {Publié} @else {Non publié}
                    </span>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="content" [ngClass]="{'on-admin': adminSide}">
        <div class="cardHeader">

        </div>

        <div class="cardContent">
            <h4 [ngStyle]="{'color': eventColor}">{{event.name}}</h4>
            @if (event.address.city) {
            <h6 class="city text-it">{{event.address.city}}</h6>
            }
        </div>

        <div class="cardFooter d-flex flex-row justify-content-around">
            @if (adminSide) {
            <div class="footer-admin d-flex flex-column justify-content-center gap-1">
                <button matButton="text" (click)="goToDashboard()">Ouvrir le dashboard</button>
                <div class="d-flex flex-row flex-end justify-content-end gap-3 actions">
                    <button matIconButton (click)="editEvent()">
                        <mat-icon class="d-flex flex-column justify-content-center align-items-center"
                            [svgIcon]="icons.EDIT"></mat-icon>
                    </button>

                    <button matIconButton [disabled]="true">
                        <mat-icon class="d-flex flex-column justify-content-center align-items-center"
                            [svgIcon]="icons.DUPLICATE"></mat-icon>
                    </button>

                    <button matIconButton type="button" (click)="deleteEvent()" disabled="true">
                        <mat-icon class="d-flex flex-column justify-content-center align-items-center"
                            [svgIcon]="icons.BIN"></mat-icon>
                    </button>
                </div>
            </div>

            } @else {
            <!-- @if (isRegistrationOpen) {
            <button type="button" class="btn btn-primary"
                [ngStyle]="{'background-color': eventColor, 'border-color': eventColor}">
                <a [href]="registrationUrl" target="_blank"
                    style="text-decoration: none; color: white !important;">S'inscrire</a>
            </button>
            } -->
            @if (hasRacesRegistred) {
            @if (isLiveTrail) {
            <a [href]="isLiveTrail" target="_blank"><img src="/assets/img/LIVETRAIL-LOGO-BLEU-CMJN.png" alt="LiveTrail"
                    class="livetrail-icon"></a>
            }@else {
            <button type="button" class="btn btn-primary"
                [ngStyle]="{'background-color': eventColor, 'border-color': eventColor}"
                [routerLink]="[linkToLive]">{{buttonFollowLabel}}</button>
            }
            }
            }
        </div>
    </div>
</div>